import { View } from 'react-native';
import { useOverlay } from '@/common/components/Overlay/Overlay.context';
import { TOverlayChildren } from '@/common/components/Overlay/Overlay.types';
import { OverlayChildren } from '@/common/components/Overlay/OverlayChildren/OverlayChildren';
import { styles } from './OverlayHeader.styles';

export function OverlayHeader({ children }: { children?: TOverlayChildren }) {
  const { scrolled } = useOverlay();

  if (!children) return null;

  return (
    <View className={styles.header({ scrolled })}>
      <OverlayChildren>{children}</OverlayChildren>
    </View>
  );
}
